export default class RoomPicker {
  constructor($container) {
    this.$container = $container

    // Hidden inputs
    this.$adults = this.$container.find('[name="adultos"]')
    this.$children = this.$container.find('[name="ninos"]')

    // Components
    this.$field = this.renderField().appendTo(this.$container)
    this.$dialog = this.renderDialog().appendTo(this.$container)

    // Events
    this.$field.click(this.openDialog.bind(this))

    // Show component
    this.$container.show()
  }

  /**
   * Renders HTML content of field
   * 
   * @returns string
   */
  renderField() {
    let content = `<span>${this.$adults.data('label')} ${this.$adults.val()}</span>`;
  
    if (this.$children.val() > 0)
      content += ` / <span>${this.$children.data('label')} ${this.$children.val()}</span>`;

    return $(`<div class="roompicker__field">${content}</div>`);
  }

  updateField() {
    this.$field.html(
      $(this.renderField()).html()
    );
  }

  /**
   * Binds close event on body click
   */
  bindCloseEvent() {
    $('body').on('click', (e) => {
      if ($(e.target).closest(this.$container).length === 0) this.closeDialog();
    });
  }

  /**
   * Remove bind on body
   */
  unbindCloseEvent() {
    $('body').off('click');
  }

  /**
   * Opens picker dialog
   */
  openDialog() {
    if (this.$container.hasClass('roompicker--dialog-open')) return;

    this.$container.addClass('roompicker--dialog-open');
    this.bindCloseEvent();
  }

  /**
   * Closes picker dialog
   */
  closeDialog() {
    if (! this.$container.hasClass('roompicker--dialog-open')) return;

    this.$container.removeClass('roompicker--dialog-open');
    this.unbindCloseEvent();
  }

  /**
   * Renders HTML content of dialog
   * 
   * @returns string
   */
  renderDialog() {
    let $dialog = $('<div class="roompicker__dialog"></div>');
    
    let $selector_adults = $(this.renderDialogSelector(this.$adults));
    this.bindEventsDialogSelector($selector_adults, this.$adults);

    let $selector_children = $(this.renderDialogSelector(this.$children));
    this.bindEventsDialogSelector($selector_children, this.$children);

    return $dialog.append($selector_adults).append($selector_children);
  }

  renderDialogSelector($input) {
    return `<div class="roompicker__row">
      <span>${$input.data('label')}</span>
      <span class="minus">-</span>
      <span class="number">${$input.val()}</span>
      <span class="plus">+</span>
    </div>`
  }

  bindEventsDialogSelector($selector, $input) {
    $selector.find('.minus').click(() => {
      let val = parseInt($input.val());

      if ($input.data('min') >= val) return;

      val = val - 1;
      $input.val(val);
      $selector.find('.number').text(val);

      this.updateField();
    });

    $selector.find('.plus').click(() => {
      let val = parseInt($input.val());

      if ($input.data('max') <= val) return;

      val = val + 1;
      $input.val(val);
      $selector.find('.number').text(val);

      this.updateField();
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/RoomPicker.js